export default __webpack_public_path__ + "static/media/Checked-circle.494d2b5e.svg";